if (typeof FreeShippingBar !== 'function') {

  class FreeShippingBar extends HTMLElement {

    constructor() {
      super();
      this._updating = false;

      const cartCountEl = document.querySelector('[data-header-cart-count]');
      if (cartCountEl) {
        this._observer = new MutationObserver(() => this._refresh());
        this._observer.observe(cartCountEl, { childList: true, characterData: true, subtree: true });
      }
    }

    async _refresh() {
      if (this._updating) return;
      this._updating = true;

      try {
        const response = await fetch(`${window.location.pathname}?section_id=free-shipping-bar`);
        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const newBar = parsed.querySelector('free-shipping-bar');

        if (newBar) {
          this.querySelector('.fs-bar-inner').innerHTML = newBar.querySelector('.fs-bar-inner').innerHTML;
          this.dataset.cartTotal = newBar.dataset.cartTotal;
        }
      } catch (e) {
        console.error('[FreeShippingBar] refresh error:', e);
      } finally {
        this._updating = false;
      }
    }

    disconnectedCallback() {
      if (this._observer) {
        this._observer.disconnect();
      }
    }

  }

  if (typeof customElements.get('free-shipping-bar') === 'undefined') {
    customElements.define('free-shipping-bar', FreeShippingBar);
  }

}
